/* eslint-disable */

class Entities {
  static validate(entities) {
    if (!entities) {
      return;
    }

    Entities._validateKeys(entities);
    Fields.validate(entities);
    EntityProperties.validate(entities, 'entities.');
  }

  static _validateKeys(entities) {
    let validKeys = [
      'fields',
      'name_plural',
      'label',
      'label_plural',
      'properties',
    ];
    Utils.validatePropertyIncludeInKeys(
      entities,
      validKeys,
      'entities.',
    );
  }
}

class EntityProperties {
  static validate(entities, parentsPath) {
    let properties = entities.properties;
    if (!properties) {
      return;
    }

    EntityProperties.validateFieldInputButNoFields(
      entities,
    );

    Object.keys(properties).forEach((key) => {
      EntityProperties._validateItem(
        key,
        properties[key],
        parentsPath + 'properties.',
      );
      EntityProperties._validateInput(
        key,
        properties[key],
        parentsPath + 'properties.',
      );

      const propertiesExceptCurrent = Object.keys(
        properties,
      ).filter((p) => p !== key);
      PropertyCondition.validate(
        properties[key].condition,
        propertiesExceptCurrent,
        `${parentsPath}properties.${key}.`,
      );
    });
  }

  static validateFieldInputButNoFields(entities) {
    Object.keys(entities.properties).forEach((key) => {
      if (
        entities.properties[key].input === 'field' &&
        !entities.fields
      ) {
        Utils.error(
          `entities.properties.${key}.input is field, but entities is configurated to not have fields`,
        );
      }
    });
  }

  static _validateItem(key, value, parentsPath) {
    let validKeys = [
      'label',
      'input',
      'help',
      'required',
      'default',
      'choices',
      'condition',
    ];
    Utils.validatePropertyIncludeInKeys(
      value,
      validKeys,
      parentsPath + key + '.',
    );
    EntityProperties._validateSelectHasChoices(
      value,
      parentsPath + key + '.',
    );
    EntityProperties._validateDefaults(
      value,
      parentsPath + key + '.',
    );
    if (value.choices) {
      EntityProperties._validateChoices(
        value.choices,
        parentsPath + key + '.choices.',
      );
    }
  }

  static _validateInput(key, value, parentsPath) {
    if (!value.input) {
      return;
    }
    let validInputs = [
      'number',
      'text',
      'select',
      'field',
      'field_to_display',
      'color',
    ];
    if (!includes(validInputs, value.input)) {
      Utils.errorInvalidValue(
        `${parentsPath ? parentsPath : ''}${key}.input`,
        validInputs,
      );
    }
  }

  static _validateChoices(choices, parentsPath) {
    let validKeys = ['label', 'help'];
    Object.keys(choices).forEach((key) => {
      Utils.validatePropertyIncludeInKeys(
        choices[key],
        validKeys,
        parentsPath + key + '.',
      );
    });
  }

  static _validateSelectHasChoices(item, parentsPath) {
    if (item.input !== 'select') {
      return;
    }
    if (
      !item.choices ||
      Object.keys(item.choices).length <= 0
    ) {
      Utils.error(
        `${parentsPath}input is 'select' but ${parentsPath}choices are empty`,
      );
    }
  }

  static _validateDefaults(item, parentsPath) {
    if (!item.default) {
      return;
    }
    if (item.input === 'select') {
      EntityProperties._validateDefaultSelect(
        item,
        parentsPath,
      );
    }
    if (item.input === 'number') {
      EntityProperties._validateDefaultNumber(
        item,
        parentsPath,
      );
    }
  }

  static _validateDefaultNumber(item, parentsPath) {
    if (isNaN(item.default)) {
      Utils.error(
        `${parentsPath}default should be a number`,
      );
    }
  }

  static _validateDefaultSelect(item, parentsPath) {
    let hasSome = Object.keys(item.choices).some((key) => {
      if (item.default === key) {
        return true;
      }
      return false;
    });
    if (!hasSome) {
      Utils.error(
        `${parentsPath}default does not match any ${parentsPath}choices`,
      );
    }
  }
}

class Fields {
  static validate(entities) {
    let fields = entities.fields;
    if (!fields) {
      return;
    }
    Fields._validateKeys(fields);
    Fields._validateElements(entities, fields);
  }
  static _validateKeys(fields) {
    let validKeys = [
      'name_plural',
      'label',
      'label_plural',
      'types',
      'relation-properties',
      'properties',
      'validations',
    ];
    Utils.validatePropertyIncludeInKeys(
      fields,
      validKeys,
      'entities.fields.',
    );
  }
  static _validateElements(entities, fields) {
    FieldValidations.validate(
      fields.validations,
      'entities.fields.',
    );
    FieldRelationProperties.validate(
      entities,
      fields['relation-properties'],
      'entities.fields.',
    );
    FieldProperties.validate(
      fields.properties,
      'entities.fields.',
    );
    FieldTypes.validate(fields, 'entities.fields.');
  }
}

class FieldTypes {
  static validate(fields, parentsPath) {
    let types = fields.types;
    if (!types) {
      return;
    }
    Object.keys(types).forEach((key) => {
      FieldTypes._validateItem(
        fields,
        key,
        types[key],
        parentsPath + 'types.',
      );
    });
  }

  static _validateItem(fields, key, value, parentsPath) {
    let validKeys = [
      'label',
      'help',
      'validations',
      'properties',
      'relation',
    ];
    Utils.validatePropertyIncludeInKeys(
      value,
      validKeys,
      parentsPath + key + '.',
    );

    if (value.validations) {
      if (
        !Utils.allArrayHasKeyinObject(
          value.validations,
          fields.validations,
        )
      ) {
        Utils.error(
          parentsPath +
            key +
            '.validations have one or more values that are not in entities.fields.validations',
        );
      }
    }
    if (value.properties) {
      if (
        !Utils.allArrayHasKeyinObject(
          value.properties,
          fields.properties,
        )
      ) {
        Utils.error(
          parentsPath +
            key +
            '.properties have one or more values that are not in entities.fields.properties',
        );
      }
    }
  }
}

class FieldRelationProperties {
  static validate(entities, properties, parentsPath) {
    if (!properties) {
      return;
    }
    FieldRelationProperties.validateReservedWord(
      properties,
      parentsPath + 'relation-properties.',
    );
    FieldRelationProperties.validateFieldInputButNoFields(
      entities,
      properties,
      parentsPath + 'relation-properties.',
    );
    Object.keys(properties).forEach((key) => {
      FieldRelationProperties._validateItem(
        key,
        properties[key],
        parentsPath + 'relation-properties.',
      );
      FieldRelationProperties._validateInput(
        key,
        properties[key],
        parentsPath + 'relation-properties.',
      );
    });
  }

  static validateReservedWord(properties, parentsPath) {
    if (properties['entity']) {
      Utils.error(
        `${parentsPath}entity is invalid, because entity is a reserved word`,
      );
    }
  }

  static validateFieldInputButNoFields(
    entities,
    properties,
    parentsPath,
  ) {
    Object.keys(properties).forEach((key) => {
      if (
        properties[key].input === 'field' &&
        !entities.fields
      ) {
        Utils.error(
          `${parentsPath}${key}.input is field, but entities is configurated to not have fields`,
        );
      }
    });
  }

  static _validateItem(key, value, parentsPath) {
    let validKeys = [
      'label',
      'input',
      'help',
      'required',
      'default',
      'choices',
    ];
    Utils.validatePropertyIncludeInKeys(
      value,
      validKeys,
      parentsPath + key + '.',
    );
    FieldRelationProperties._validateSelectHasChoices(
      value,
      parentsPath + key + '.',
    );
    FieldRelationProperties._validateDefaults(
      value,
      parentsPath + key + '.',
    );
    if (value.choices) {
      FieldRelationProperties._validateChoices(
        value.choices,
        parentsPath + key + '.choices.',
      );
    }
  }

  static _validateInput(key, value, parentsPath) {
    if (!value.input) {
      return;
    }
    let validInputs = [
      'number',
      'text',
      'select',
      'field',
      'field_to_display',
      'color',
    ];
    if (!includes(validInputs, value.input)) {
      Utils.errorInvalidValue(
        `${parentsPath ? parentsPath : ''}${key}.input`,
        validInputs,
      );
    }
  }

  static _validateChoices(choices, parentsPath) {
    let validKeys = ['label', 'help'];
    Object.keys(choices).forEach((key) => {
      Utils.validatePropertyIncludeInKeys(
        choices[key],
        validKeys,
        parentsPath + key + '.',
      );
    });
  }

  static _validateSelectHasChoices(item, parentsPath) {
    if (item.input !== 'select') {
      return;
    }
    if (
      !item.choices ||
      Object.keys(item.choices).length <= 0
    ) {
      Utils.error(
        `${parentsPath}input is 'select' but ${parentsPath}choices are empty`,
      );
    }
  }

  static _validateDefaults(item, parentsPath) {
    if (!item.default) {
      return;
    }
    if (item.input === 'select') {
      FieldRelationProperties._validateDefaultSelect(
        item,
        parentsPath,
      );
    }
    if (item.input === 'number') {
      FieldRelationProperties._validateDefaultNumber(
        item,
        parentsPath,
      );
    }
  }

  static _validateDefaultNumber(item, parentsPath) {
    if (isNaN(item.default)) {
      Utils.error(
        `${parentsPath}default should be a number`,
      );
    }
  }

  static _validateDefaultSelect(item, parentsPath) {
    let hasSome = Object.keys(item.choices).some((key) => {
      if (item.default === key) {
        return true;
      }
      return false;
    });
    if (!hasSome) {
      Utils.error(
        `${parentsPath}default does not match any ${parentsPath}choices`,
      );
    }
  }
}

class FieldProperties {
  static validate(properties, parentsPath) {
    if (!properties) {
      return;
    }
    Object.keys(properties).forEach((key) => {
      FieldProperties._validateItem(
        key,
        properties[key],
        parentsPath + 'properties.',
      );
      FieldProperties._validateInput(
        key,
        properties[key],
        parentsPath + 'properties.',
      );

      const propertiesExceptCurrent = Object.keys(
        properties,
      ).filter((p) => p !== key);
      PropertyCondition.validate(
        properties[key].condition,
        propertiesExceptCurrent,
        `${parentsPath}properties.${key}`,
      );
    });
  }

  static _validateItem(key, value, parentsPath) {
    let validKeys = [
      'label',
      'input',
      'help',
      'required',
      'default',
      'choices',
      'condition',
    ];
    Utils.validatePropertyIncludeInKeys(
      value,
      validKeys,
      parentsPath + key + '.',
    );
    FieldProperties._validateSelectHasChoices(
      value,
      parentsPath + key + '.',
    );
    FieldProperties._validateDefaults(
      value,
      parentsPath + key + '.',
    );
    if (value.choices) {
      FieldProperties._validateChoices(
        value.choices,
        parentsPath + key + '.choices.',
      );
    }
  }

  static _validateInput(key, value, parentsPath) {
    if (!value.input) {
      return;
    }
    let validInputs = ['number', 'text', 'select', 'color'];
    if (!includes(validInputs, value.input)) {
      Utils.errorInvalidValue(
        `${parentsPath ? parentsPath : ''}${key}.input`,
        validInputs,
      );
    }
  }

  static _validateChoices(choices, parentsPath) {
    let validKeys = ['label', 'help'];
    Object.keys(choices).forEach((key) => {
      Utils.validatePropertyIncludeInKeys(
        choices[key],
        validKeys,
        parentsPath + key + '.',
      );
    });
  }

  static _validateSelectHasChoices(item, parentsPath) {
    if (item.input !== 'select') {
      return;
    }
    if (
      !item.choices ||
      Object.keys(item.choices).length <= 0
    ) {
      Utils.error(
        `${parentsPath}input is 'select' but ${parentsPath}choices are empty`,
      );
    }
  }

  static _validateDefaults(item, parentsPath) {
    if (!item.default) {
      return;
    }
    if (item.input === 'select') {
      FieldProperties._validateDefaultSelect(
        item,
        parentsPath,
      );
    }
    if (item.input === 'number') {
      FieldProperties._validateDefaultNumber(
        item,
        parentsPath,
      );
    }
  }

  static _validateDefaultNumber(item, parentsPath) {
    if (isNaN(item.default)) {
      Utils.error(
        `${parentsPath}default should be a number`,
      );
    }
  }

  static _validateDefaultSelect(item, parentsPath) {
    let hasSome = Object.keys(item.choices).some((key) => {
      if (item.default === key) {
        return true;
      }
      return false;
    });
    if (!hasSome) {
      Utils.error(
        `${parentsPath}default does not match any ${parentsPath}choices`,
      );
    }
  }
}

class FieldValidations {
  static validate(validations, parentsPath) {
    if (!validations) {
      return;
    }
    Object.keys(validations).forEach((key) => {
      FieldValidations._validateValidation(
        key,
        validations[key],
        parentsPath + 'validations.',
      );
      FieldValidations._validateInput(
        key,
        validations[key],
        parentsPath + 'validations.',
      );
    });
  }

  static _validateValidation(key, value, parentsPath) {
    let validKeys = ['label', 'input', 'help'];
    Utils.validatePropertyIncludeInKeys(
      value,
      validKeys,
      parentsPath + key + '.',
    );
  }

  static _validateInput(key, value, parentsPath) {
    if (!value.input) {
      return;
    }
    let validInputs = ['number', 'text'];
    if (!includes(validInputs, value.input)) {
      Utils.errorInvalidValue(
        `${parentsPath ? parentsPath : ''}${key}.input`,
        validInputs,
      );
    }
  }
}

class Properties {
  static validate(properties, entities) {
    if (!properties) {
      return;
    }

    Properties.validateEntityInputButNoEntities(
      properties,
      entities,
    );
    Object.keys(properties).forEach((key) => {
      Properties.validateProperty(key, properties[key]);

      const propertiesExceptCurrent = Object.keys(
        properties,
      ).filter((p) => p !== key);
      PropertyCondition.validate(
        properties[key].condition,
        propertiesExceptCurrent,
        `properties.${key}`,
      );
    });
  }

  static validateEntityInputButNoEntities(
    properties,
    entities,
  ) {
    Object.keys(properties).forEach((key) => {
      if (properties[key].input === 'entity' && !entities) {
        Utils.error(
          `properties.${key}.input is entity, but scaffold is configurated to not have entities`,
        );
      }
    });
  }

  static validateProperty(key, value) {
    let validKeys = [
      'help',
      'label',
      'input',
      'default',
      'choices',
      'required',
      'condition',
    ];
    Utils.validatePropertyIncludeInKeys(
      value,
      validKeys,
      'properties.' + key,
    );
    Properties.validateInput(
      key,
      value,
      'properties.' + key,
    );
    Properties.validateSelectHasChoices(
      value,
      'properties.' + key,
    );
    if (value.choices) {
      Properties.validatePropertyChoices(
        value.choices,
        'properties.' + key,
      );
    }
  }

  static validateInput(key, value, parentsPath) {
    if (!value.input) {
      return;
    }
    let validInputs = [
      'number',
      'text',
      'select',
      'entity',
      'color',
    ];
    if (!includes(validInputs, value.input)) {
      Utils.errorInvalidValue(
        `${parentsPath}.input`,
        validInputs,
      );
    }
  }

  static validateSelectHasChoices(value, parentsPath) {
    if (value.input !== 'select') {
      return;
    }
    if (
      !value.choices ||
      Object.keys(value.choices).length <= 0
    ) {
      Utils.error(
        `${parentsPath}.input is 'select' but ${parentsPath}.choices are empty`,
      );
    }
  }

  static validatePropertyChoices(choices, parentsPath) {
    let validKeys = ['label', 'help'];
    Object.keys(choices).forEach((key) => {
      Utils.validatePropertyIncludeInKeys(
        choices[key],
        validKeys,
        parentsPath + '.choices.' + key,
      );
    });
  }
}

class PropertyCondition {
  static validate(
    condition,
    propertiesAvailable,
    parentsPath,
  ) {
    if (!condition) {
      return;
    }

    Utils.validatePropertyIncludeInKeys(
      condition,
      ['type', 'property', 'operation', 'value'],
      `${parentsPath}.condition.`,
    );

    if (
      !condition.property ||
      propertiesAvailable.indexOf(condition.property) === -1
    ) {
      Utils.errorInvalidValue(
        `${parentsPath}.condition.property`,
        propertiesAvailable,
      );
    }

    const validOperations = [
      '=',
      '!=',
      '<=',
      '>=',
      '<',
      '>',
    ];
    if (
      validOperations.indexOf(condition.operation) === -1
    ) {
      Utils.errorInvalidValue(
        `${parentsPath}.condition.operation`,
        validOperations,
      );
    }
  }
}

class Utils {
  static validatePropertyIncludeInKeys(
    object,
    validKeys,
    parentsPath,
  ) {
    Object.keys(object).forEach((key) => {
      if (!validKeys.includes(key)) {
        Utils.errorInvalidProperty(
          `${parentsPath ? parentsPath : ''}${key}`,
          validKeys,
        );
      }
    });
  }

  static allArrayHasKeyinObject(array, obj) {
    if (!array) {
      return true;
    }
    if (!obj) {
      return false;
    }
    if (!Array.isArray(array)) {
      return false;
    }
    return array.every((inArray) => {
      return Object.keys(obj).some(
        (key) => inArray === key,
      );
    });
  }

  static error(message) {
    throw new Error(
      `Error on scaffoldhub/config.yml: ${message}`,
    );
  }

  static errorInvalidValue(value, valids) {
    Utils.error(
      `Invalid value for '${value}'. Valid values are '${valids.join(
        "', '",
      )}'.`,
    );
  }
  static errorInvalidProperty(property, valids) {
    Utils.error(
      `Invalid '${property}'. Valid properties are '${valids.join(
        "', '",
      )}'.`,
    );
  }
}

function includes(arr, searchElement) {
  let O = Object(arr);
  let len = parseInt(O.length, 10) || 0;
  if (len === 0) {
    return false;
  }
  let n = parseInt(arguments[1], 10) || 0;
  let k;
  if (n >= 0) {
    k = n;
  } else {
    k = len + n;
    if (k < 0) {
      k = 0;
    }
  }
  let currentElement;
  while (k < len) {
    currentElement = O[k];
    if (
      searchElement === currentElement ||
      (searchElement !== searchElement &&
        currentElement !== currentElement)
    ) {
      // NaN !== NaN
      return true;
    }
    k++;
  }
  return false;
}

export default class ScaffoldConfigValidator {
  constructor(config) {
    this.config = config;
  }

  validate() {
    this.validateRoots();
    Properties.validate(
      this.config.properties,
      this.config.entities,
    );
    Entities.validate(this.config.entities);
  }

  validateRoots() {
    let validKeys = [
      'runnable',
      'entities',
      'properties',
      'relationships',
    ];
    Utils.validatePropertyIncludeInKeys(
      this.config,
      validKeys,
    );
  }
}
